import { Widget, WidgetCounters, WidgetSession } from "../../types";
import BaseController from "./BaseController";

class WidgetController extends BaseController {
  static get(): Promise<{ widget: Widget, session: WidgetSession }> {
    return this.post('messenger/launcher')
  }

  static ping(): Promise<void> {
    return this.post('messenger/ping')
  }

  static open(): Promise<void> {
    return this.post('messenger/open')
  }

  static counters(): Promise<WidgetCounters> {
    return this.post('messenger/counters')
  }
}

export default WidgetController